<script lang="ts" setup>
import { ButtonQC } from '@qicgroupdoha/qic-connect-ds';

import { usePolicyStore } from '@/entities/Policy';
import { GA_EVENTS, useGoogleAnalytics } from '@/shared/analytics';
import { WhatsAppIcon } from '@/shared/ui/icons';

interface WhatsAppButtonProps {
  title?: string;
  text?: string;
  href?: string;
}

const props = withDefaults(defineProps<WhatsAppButtonProps>(), {
  title: '',
  text: '',
});

const gaService = useGoogleAnalytics();
const policyStore = usePolicyStore();

function clickEventWhatsUp() {
  gaService.send(GA_EVENTS.CLICK_WHATSAPP, {
    ...(props.title && { title: props.title }),
    ...(props.text && { title: props.text }),
    policy_id: policyStore.state.policyId,
  });
}
</script>

<template>
  <a :href="href" class="whatsapp-link" target="_blank nofollow noopener" data-test="whatsapp-phone">
    <ButtonQC class="whatsapp-btn" size="medium" @click="clickEventWhatsUp">
      <template #icon-before-content><WhatsAppIcon /></template>
      {{ $t('qic.help.whatsapp') }}
    </ButtonQC>
  </a>
</template>

<style lang="scss" scoped>
@use './WhatsAppButton';
</style>
